import raePic from "@/public/images/artists/rae.png";
import { Artist } from "@/types/types";

export const rae = {
  id: "31",
  name: "Rae",
  image: raePic,
  description: `Meet "Rae," the British rap sensation with razor-sharp lyricism and an unmistakable accent. Rae's dynamic delivery and unwavering confidence create a magnetic energy that sets him apart.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Frae-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop"],
      secondary: ["Rapper", "British", "Authentic"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 65,
      },
    },
  },
} as const satisfies Artist;
